/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ask_3Inputs */

const en_cp_ask_3 = /** @type {(inputs: Cp_Ask_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tier's minimum number of teams, one invoice per semester`)
};

const id_cp_ask_3 = /** @type {(inputs: Cp_Ask_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah tim minimum sesuai tier, 1 invoice per semester`)
};

/**
* | output |
* | --- |
* | "The tier's minimum number of teams, one invoice per semester" |
*
* @param {Cp_Ask_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ask_3 = /** @type {((inputs?: Cp_Ask_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ask_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ask_3(inputs)
	return en_cp_ask_3(inputs)
});